import React, { Component } from "react";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";
import GymList from '../../GymsScreen/GymList';
import theme from '../../../../Theme/theme'
import { toast } from "react-toastify";
import { Constants } from "../../../../common/constants"
import { alert, isValidAlphaNumeric } from '../../../../common/Utils'
import { API_URL, ERROR_HANDLE, GYM_TAG_UNIQUE_ID } from "config/constants";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import SlideSwitch from "../../../../components/SlideSwitch";
import PackagesList from './PackagesList';

const DISCOUNT_TEXT = "Discount Percentage"
const PROMO_TEXT = "Promo code"
const DESCRIPTION_TEXT = "Description"
const VALIDITY_DAYS = "Number of days valid"
const PRICE = "Price in $"
const SHOW_ON_APP = "Show On App"
const EXPIRY = "Expiry"
const NUMBER_OF_SESSIONS = "Number of sessions"
const NOTIFY_USER_TEXT = "Notify User"
const UPDATE_TEXT = "Update"
const DISCOUNT_ALERT_TEXT = "Please enter discount percentage value less than 100"
const START_DATE_ALERT_TEXT = "Please select date on or before end date"
const END_DATE_ALERT_TEXT = "Please select date on or after start date"
const PROMO_TYPE_DEFAULT = "discount"
const PROMO_FREQUENCY_TYPE_DEFAULT = "ONCE"
const PROMO_DESCRIPTION = "Description Details"
const HINT_OPTIONAL = "Optional"
const SESSION_LENGTH = "Session Length";
const CLASS_CORE = "CORE";
const CLASS_VPT = "VPT";
const CLASS_VPT_PACKAGE = "VPT_PACKAGE";
const CLASS_VPT_PACKAGE_DISCOUNT = "VPT_PACKAGE_DISCOUNT";
const PROMO_CLASS = [CLASS_CORE, CLASS_VPT, CLASS_VPT_PACKAGE, CLASS_VPT_PACKAGE_DISCOUNT];


const PROMO_FREQUENCY_TYPE = {
  once: "Once",
  multiple: "Multiple"
}

class CreatePromocode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoId: null,
      promocode: "",
      type: PROMO_TYPE_DEFAULT,
      frequency: PROMO_FREQUENCY_TYPE_DEFAULT,
      qty: "",
      description: "",
      startDate: moment(),
      endDate: moment(),
      gymsList: [],
      gymsSelected: [],
      validity: '',
      usageLimit: '',
      displayUsageLimit: false,
      promoClass: CLASS_CORE,
      sessionLength: new Set([]),
      price: null,
      showOnApp: false,
      packagesList: [],
      packagesSelected: [],
      tag: null,
      packagesTags: null,
    };
    this.alertMessage = "";
  }

  componentDidMount() {
    this.isEditFlow() && this.getPromoCode(this.props.location.state.promoId);
    this.getPackagesTags();
  }

  getPromoCode(promoId) {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Fetching promo code...");
    axios
      .get(`${API_URL}/promos/${promoId}`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        const promoDetail = res.data;
        this.setState({
          promoId: promoDetail.promo_id,
          promocode: promoDetail.promocode,
          type: promoDetail.type,
          qty: promoDetail.qty,
          description: promoDetail.description,
          gymsSelected: promoDetail.gyms,
          frequency: promoDetail.frequency,
          startDate: promoDetail.from ? moment(promoDetail.from) : null,
          endDate: promoDetail.to ? moment(promoDetail.to) : null,
          validity: promoDetail.validity ? promoDetail.validity : '',
          usageLimit: promoDetail.usageLimit ? promoDetail.usageLimit : '',
          displayUsageLimit: promoDetail.frequency.toUpperCase() != PROMO_FREQUENCY_TYPE_DEFAULT,
          promoClass: promoDetail.class,
          sessionLength: promoDetail.sessionLength ? new Set(promoDetail.sessionLength) : new Set([]),
          price: promoDetail.price,
          showOnApp: promoDetail.showOnApp,
          packagesSelected: promoDetail.packages ? promoDetail.packages : [],
          tag: promoDetail.tag
        }, () => {
          this._gymListRef && this._gymListRef.updateSelectedGymList();
        })
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  getPackagesTags() {
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Just a moment...");
    axios
      .get(`${API_URL}/promos/packages/tags`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        const packagesTags = res.data;
        this.setState({
          packagesTags: packagesTags
        })
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  savePromoCode(isCreate, promoId) {
    let url, method, fetchMessage, successMessage;
    if (isCreate) {
      url = `${API_URL}/promos`;
      method = 'POST';
      fetchMessage = "Creating Promocode...";
      successMessage = "Added Successfully";
    } else {
      url = `${API_URL}/promos/${promoId}`;
      method = 'PUT';
      fetchMessage = "Updating Promocode...";
      successMessage = "Updated Successfully";
    }
    const toastId = toast(fetchMessage);
    const access_token = localStorage.getItem("access_token");
    const {
      promocode,
      type,
      qty,
      description,
      frequency,
      startDate,
      endDate,
      validity,
      usageLimit,
      promoClass,
      sessionLength,
      price,
      showOnApp,
      tag
    } = this.state;
    const data = {
      type: type.toLowerCase(),
      qty,
      description,
      from: startDate,
      to: endDate,
      frequency: frequency.toLowerCase(),
      gyms: this.getGyms(),
      validity: validity ? validity : null,
      usageLimit: usageLimit ? usageLimit : null,
      class: promoClass,
      packages: this.state.packagesSelected,
    };
    if (isCreate) {
      data.promocode = promocode;
    }
    // Add the session length paramater only for VPT or VPT_PACKAGE promo code.
    if (promoClass == CLASS_VPT || promoClass == CLASS_VPT_PACKAGE) {
      data.sessionLength = Array.from(sessionLength);
    }
    // Add the price parameter only for VPT_PACKAGE promo code. 
    if (promoClass == CLASS_VPT_PACKAGE) {
      data.price = price;
      // Remove the expiry for VPT Package.
      data.from = null;
      data.to = null;
      data.showOnApp = showOnApp;
      data.tag = tag ? tag : 1;
    }
    axios({
      url,
      method: method,
      headers: {
        "Content-Type": "application/json",
        "x-access-token": access_token
      },
      data
    }).then(res => {
      toast.dismiss(toastId);
      toast(successMessage, { autoClose: 1500 });
      this.props.history.push('/promocodes/')
    }).catch(err => {
      toast.dismiss(toastId);
      ERROR_HANDLE(err);
    });
  }

  isValidPromoCode() {
    let isValid = true;
    if (!isValidAlphaNumeric(this.state.promocode)) {
      this.alertMessage = Constants.ALERT_PROMO_CODE
      isValid = false
    }
    return isValid;
  }

  isValidQuantityValue() {
    let isValid = true;
    if (this.state.qty > 100) {
      this.alertMessage = DISCOUNT_ALERT_TEXT
      isValid = false
    }
    return isValid;
  }

  isValidVPTPromo() {
    let isValid = true;
    if (this.state.promoClass == CLASS_VPT || this.state.promoClass == CLASS_VPT_PACKAGE) {
      if (this.state.sessionLength.size == 0) {
        this.alertMessage = Constants.ALERT_SELECT_SESSION_LENGTH;
        isValid = false
      }
    }
    return isValid;
  }

  isValidVPTPackage() {
    let isValid = true;
    if (this.state.promoClass == CLASS_VPT_PACKAGE) {
      if (!this.state.usageLimit) {
        this.alertMessage = Constants.ALERT_ENTER_SESSIONS;
        isValid = false
      }
      if (!this.state.price) {
        this.alertMessage = Constants.ALERT_ENTER_PRICE;
        isValid = false
      }
    }
    return isValid;
  }

  getGyms() {
    const gymsSelectedList = this.getSelectedGyms();
    if (gymsSelectedList.gyms.length === this.state.gymsList.length) {
      //All gyms selected
      return "all"
    } else {
      return gymsSelectedList.gyms.length === 0 ? null : gymsSelectedList.gyms.join(",")
    }
  }

  getSelectedGyms() {
    let gyms = []
    let gymTags = []
    this.state.gymsSelected.map((gym) => {
      gym.gym_id.toString().includes(GYM_TAG_UNIQUE_ID) ? gymTags.push(parseInt(gym.gym_id)) : gyms.push(parseInt(gym.gym_id))
    })
    return { gyms, gymTags }
  }

  /**
   * @description this is the props method gets handled from gym list component to avoid gyms API call every time.
   * @param gymsList - the gymsList value will receive from gym list component
   */
  updateGymsList = (gymsList) => {
    this.setState({
      gymsList
    })
  }

  /**
   * @description this is the props method gets handled from gym list component to update selected gyms.
   * @param gymsList - the selected gymsList value will receive from gym list component
   */
  updateSelectedGyms = (gymsSelected) => {
    this.setState({
      gymsSelected
    })
  }

  updatePackagesList = (packagesList) => {
    this.setState({
      packagesList
    })
  }

  updateSelectedPackages = (packagesSelected) => {
    this.setState({
      packagesSelected
    })
  }

  handleStartDate = date => {
    //update the start date only if it is less than or equal to end date and future date.
    moment(date).isSameOrBefore(this.state.endDate) ?
      this.setState({
        startDate: date
      }) : alert(START_DATE_ALERT_TEXT)
  };

  handleEndDate = date => {
    //update the end date only if it is greater than or equal to start and less than or equal to future date.
    moment(date).isSameOrAfter(this.state.startDate) ?
      this.setState({
        endDate: date
      }) : alert(END_DATE_ALERT_TEXT)
  };

  switchTypes = event => {
    let promoClass = event.target.value;
    this.setState({
      promoClass: promoClass,
      validity: '',
      usageLimit: '',
      sessionLength: new Set([]),
      price: null,
      frequency: promoClass == CLASS_VPT_PACKAGE ? 'multiple' : 'once',
      displayUsageLimit: promoClass == CLASS_VPT_PACKAGE,
    });
  };

  switchFrequency = event => {
    let value = event.target.value;
    this.setState({
      frequency: value,
      usageLimit: '',
      displayUsageLimit: value.toUpperCase() != PROMO_FREQUENCY_TYPE_DEFAULT
    });
  };

  switchTag = event => {
    let value = event.target.value;
    this.setState({
      tag: value
    });
  }

  isEditFlow() {
    return this.props.location.state && this.props.location.state.promoId ? true : false
  }

  handleChange(evt, key) {
    const value = (evt.target.validity.valid) ? evt.target.value : this.state[key];
    let state = this.state;
    state[key] = value;
    this.setState(state);
  }

  renderSessionLengths = () => {
    if (this.state.promoClass == CLASS_VPT || this.state.promoClass == CLASS_VPT_PACKAGE)
      return <div style={style.selectorWrapper}>
        <p style={style.selectorLabel}>{SESSION_LENGTH}</p>
        <div className="create-promo-duration-container">
          {Constants.SESSION_DURATIONS.map((duration) => { return this.renderDuration(duration) })}
        </div>
      </div>
  }

  renderDuration = (value) => {
    let sessionLength = this.state.sessionLength;
    return <div className={`create-promo-duration unselectable ${sessionLength.has(value) ? "create-promo-duration-selected" : ""}`}
      onClick={() => {
        // VPT_PACKAGE session length should be only one.
        if (this.state.promoClass == 'VPT_PACKAGE') {
          sessionLength.clear();
          sessionLength.add(value);
        } else {
          if (sessionLength.has(value)) {
            sessionLength.delete(value);
          } else {
            sessionLength.add(value);
          }
        }
        this.setState({
          sessionLength
        })
      }}
    >{value}min</div>
  }

  render() {
    const isVPTPackage = (this.state.promoClass == CLASS_VPT_PACKAGE);
    const disableStyle = this.isEditFlow() ? { backgroundColor: theme.color.grey, color: theme.color.textLightWhite } : {}
    let promoTypeOptions = [], promoFrequencyOptions = [], packagesTagsOptions = [];
    PROMO_CLASS.forEach((promoClass, index) => {
      promoTypeOptions.push(<option key={"promoType" + index} selected={this.state.promoClass == promoClass} value={promoClass}>{promoClass}</option>);
    })
    Object.keys(PROMO_FREQUENCY_TYPE).forEach((promoFrequency, index) => {
      promoFrequencyOptions.push(<option key={"promoFrequency" + index} selected={this.state.frequency.toLowerCase() == promoFrequency.toLowerCase()} value={promoFrequency.toLowerCase()}>{PROMO_FREQUENCY_TYPE[promoFrequency]}</option>);
    })
    isVPTPackage && this.state.packagesTags && Object.keys(this.state.packagesTags).forEach((packagesTag, index) => {
      packagesTagsOptions.push(<option key={"packagesTag" + index} selected={this.state.tag == this.state.packagesTags[packagesTag]} value={this.state.packagesTags[packagesTag]}>{packagesTag}</option>);
    });
    return (
      <div style={style.wrapper}>
        <Box style={style.box} outline>
          <div>
            <div style={style.selectorWrapper}>
              <select
                disabled={this.isEditFlow()}
                onChange={this.switchTypes}
                style={style.dropDown}
              >
                {promoTypeOptions}
              </select>
              {!isVPTPackage && <select
                onChange={this.switchFrequency}
                style={style.dropDown}
              >
                {promoFrequencyOptions}
              </select>}
              {isVPTPackage && <select
                onClick={!this.state.packagesTags ? this.getPackagesTags() : () => {}}
                onChange={this.switchTag}
                style={style.dropDown}
              >
                {packagesTagsOptions}
              </select>}
            </div>
            <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{DISCOUNT_TEXT} </p>
              <input
                disabled={this.isEditFlow() && isVPTPackage}
                type="text"
                style={{ ...style.input, ...style.max }}
                value={this.state.qty}
                name="qty"
                pattern="[0-9]*"
                onInput={(evt) => { this.handleChange(evt, 'qty') }}
              />
            </div>
            <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>
                {PROMO_TEXT}
              </p>
              <input
                type="text"
                style={{ ...style.input, ...disableStyle, ...style.max }}
                value={this.state.promocode}
                name={PROMO_TEXT}
                disabled={this.isEditFlow()}
                onChange={e => {
                  this.setState({
                    promocode: e.target.value
                  });
                }}
              />
            </div>
            <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{DESCRIPTION_TEXT}</p>
              <textarea
                placeholder={PROMO_DESCRIPTION}
                style={{ ...style.textarea, ...style.max }}
                value={this.state.description}
                name={DESCRIPTION_TEXT}
                onChange={e => {
                  this.setState({
                    description: e.target.value
                  });
                }}
              />
            </div>
            {!isVPTPackage && <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{EXPIRY}</p>
              <div style={{ flexDirection: 'row', ...style.max }}>
                <p>From </p>
                <DatePicker
                  locale="en-us"
                  disabled={this.isEditFlow() && moment(this.state.startDate).isBefore(new Date())}
                  selected={this.state.startDate}
                  onChange={this.handleStartDate}
                  minDate={moment().toDate()}
                />
                <p>To </p>
                <DatePicker
                  locale="en-us"
                  disabled={this.isEditFlow() && moment(this.state.endDate).isBefore(new Date())}
                  selected={this.state.endDate}
                  onChange={this.handleEndDate}
                  minDate={moment().toDate()}
                />
              </div>
            </div>}
            {!isVPTPackage && <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{VALIDITY_DAYS} </p>
              <input
                placeholder={HINT_OPTIONAL}
                style={{ ...style.input, ...style.max }}
                name={VALIDITY_DAYS}
                value={this.state.validity}
                type="text"
                pattern="[0-9]*"
                maxLength="5"
                onInput={(evt) => { this.handleChange(evt, 'validity') }}
              />
            </div>}
            {this.state.displayUsageLimit && <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{NUMBER_OF_SESSIONS} </p>
              <input
                placeholder={isVPTPackage ? "" : HINT_OPTIONAL}
                style={{ ...style.input, ...style.max }}
                name={NUMBER_OF_SESSIONS}
                value={this.state.usageLimit}
                type="text"
                pattern="[0-9]*"
                maxLength="5"
                onInput={(evt) => { this.handleChange(evt, 'usageLimit') }}
              />
            </div>}
            {this.renderSessionLengths()}
            {isVPTPackage && <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{PRICE} </p>
              <input
                style={{ ...style.input, ...style.max }}
                name={PRICE}
                value={this.state.price}
                type="number"
                step="0.01"
                maxLength="7"
                onInput={(evt) => { this.handleChange(evt, 'price') }}
              />
            </div>}
            {isVPTPackage && <div style={style.selectorWrapper}>
              <p style={style.selectorLabel}>{SHOW_ON_APP} </p>
              <SlideSwitch style={style.switchBtn} checked={this.state.showOnApp} onClick={() => {
                this.setState({
                  showOnApp: !this.state.showOnApp
                })
              }} />
            </div>}
            <div style={style.notifyButtonWrapper}>
              <Button
                style={style.notifyButton}
                type="holo"
                holo
                onClick={() => {
                  if (this.isValidPromoCode() && this.isValidQuantityValue() && this.isValidVPTPromo() && this.isValidVPTPackage()) {
                    this.isEditFlow() ? this.state.promoId && this.savePromoCode(false, this.state.promoId) : this.savePromoCode(true)
                  } else {
                    alert(this.alertMessage);
                  }
                }}
              >
                {this.isEditFlow() ? UPDATE_TEXT : NOTIFY_USER_TEXT}
              </Button>
            </div>
          </div>
          <div>
            {this.state.promoClass == CLASS_CORE &&
              < GymList
                ref={gymListRef => this._gymListRef = gymListRef}
                gymsList={this.state.gymsList}
                gymsSelected={this.state.gymsSelected ? this.state.gymsSelected : []}
                updateGymsList={(gymsList) => this.updateGymsList(gymsList)}
                updateSelectedGyms={(gymsSelected) => this.updateSelectedGyms(gymsSelected)}
                showGymTag={false}
                selectAllGyms={!this.isEditFlow()}
              />
            }
            {this.state.promoClass == CLASS_VPT_PACKAGE_DISCOUNT &&
              < PackagesList
                packagesList={this.state.packagesList}
                packagesSelected={this.state.packagesSelected}
                updatePackagesList={(list) => this.updatePackagesList(list)}
                updateSelectedPackages={(selected) => this.updateSelectedPackages(selected)}
              />
            }
          </div>
        </Box>
      </div >
    );
  }
}
export default CreatePromocode;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    margin: "40px"
  },
  max: {
    flex: 1,
    display: 'flex'
  },
  box: {
    width: "1200px",
    display: "flex",
    justifyContent: "space-around",
    padding: "40px"
  },
  notifyButtonWrapper: {
    width: "100%",
    justifyContent: "flex-start"
  },
  notifyButton: {
    width: "230px",
    height: "48px",
    fontSize: "18px"
  },
  textarea: {
    resize: "none",
    width: "75%",
    height: "200px",
    borderRadius: "40px",
    fontSize: "20px",
    color: "#444445",
    padding: "25px"
  },
  selectorWrapper: {
    display: "flex",
    alignItems: "baseline",
    flexWrap: "nowrap"
  },
  dropDown: {
    width: 200,
    fontSize: 18,
    height: 50,
    backgroundColor: theme.color.primaryBlue,
    marginRight: 50
  },
  selectorLabel: {
    fontSize: "22px",
    textAlign: "left",
    color: "#444445",
    marginRight: "15px",
    flex: 1,
  },
  input: {
    border: "1px solid #444445",
    borderRadius: "50px",
    fontSize: "22px",
    color: "#00b4d2",
    padding: "10px"
  },
  datePicker: {
    backgroundColor: "green"
  },
  switchBtn: {
    flex: 2,
    alignItems: 'left',
  }
};
